import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import OktaSignInWidget from "./OktaSignInWidget";
import { inject, observer } from "mobx-react";
import { withStyles } from "@material-ui/core/styles";
import bg from "../images/mlb-okta-bg.jpeg";

const styles = () => ({
  background: {
    position: "absolute",
    backgroundImage: `url(${bg})`,
    backgroundSize: "cover",
    height: "100vh",
    width: "100vw"
  }
});

/**
 * This component was fork lifted from the okta-react documentation.
 * See https://github.com/okta/okta-oidc-js/tree/master/packages/okta-react for more info.
 */
class Login extends Component {
  constructor(props) {
    super(props);
    this.props.authStore.checkAuthentication();
  }

  componentDidUpdate() {
    this.props.authStore.checkAuthentication();
  }

  render() {
    const { classes } = this.props;
    const { isAuthenticated, onSuccess, onError } = this.props.authStore;
    if (isAuthenticated === null) return null;
    return isAuthenticated ? (
      <Redirect to={{ pathname: "/" }} />
    ) : (
      <div className={classes.background}>
        <OktaSignInWidget
          baseUrl={this.props.baseUrl}
          onSuccess={onSuccess}
          onError={onError}
        />
      </div>
    );
  }
}

export default inject("authStore")(withStyles(styles)(observer(Login)));



// WEBPACK FOOTER //
// ./src/components/Login.js